export const textData = [
  ['不忘初心跟党走。', '跟党走'],
  ['爱国，奋斗，建功自贸港。', '建功自贸港'],
  ['为海南自贸港建设贡献智慧和力量。', '贡献力量'],
  ['践行文明公约，争当文明有礼的昌江人。', '践行文明公约'],
  ['建设昌江，奉献家乡。', '奉献家乡'],
  ['百善孝为先，多陪伴父母。', '孝顺父母'],
  ['关爱父母长辈，尊老、敬老。', '关爱长辈'],
  ['重视家庭教育，传好家训、立好家规、守好家风。', '传承好家风'],
  ['培养子女自信自强、勤俭节约、敬老爱幼。', '培养子女'],
  ['感谢生命中出现的每一位师者。', '感恩老师'],
  ['言必信，行必果。', '知行合一'],
  ['学雷锋，做好事。', '做好事'],
  ['无偿献血，拯救生命。', '无偿献血'],
  ['有困难，找志愿者；有时间，当志愿者。', '争当志愿者'],
  ['积极参与捐资助学、扶贫济困、关爱他人等公益活动。', '参与公益'],
  ['勤俭节约，爱惜粮食，一粥一饭当思来之不易。', '珍惜粮食'],
  ['节约用水，节约用电。', '节水节电'],
  ['珍惜能源，绿色出行。', '绿色出行'],
  ['爱护树木，保护花草。', '爱护大自然'],
  ['从我做起，保护环境、呵护生态、爱护公物。', '爱护公物'],
  ['倒垃圾，先分类。', '垃圾分类'],
  ['读好书，写好字，做好人。', '做好人'],
  ['文明上网，不造谣、不信谣、不传谣。', '不信谣不传谣'],
  ['不在网上谩骂、诋毁、诽谤他人。', '禁止网络暴力'],
  ['远离色情、暴力、恐怖信息。', '远离色情'],
  ['为了自己和家人的健康，不吸烟。', '爱护健康'],
  ['不乱扔烟头烟盒、不乱弹烟灰，烟蒂要完全熄灭。', '不乱扔烟头'],
  ['祭而丰不如养之厚，生前尽孝厚养，身后文明薄葬。', '文明丧葬'],
  ['不攀比、不浪费，红事、白事节俭办。', '红事简办'],
  ['绿色殡葬、文明祭扫，不在山头和林地焚烧纸钱、抛洒祭品。', '文明祭扫'],
  ['乔迁、升学，不办酒、不请客、不受请、不送礼。', '不收礼不送礼'],
  ['相信科学，不迷信。', '不迷信'],
  ['不贪小便宜，以免上当受骗。', '不贪小便宜'],
  ['不沉迷游戏。', '不沉迷游戏'],
  ['不涉黄、不涉毒、不涉赌。', '不涉黄赌毒'],
  ['低俗不沾。', '低俗不沾'],
  ['远离酒桌牌桌。', '不酗酒不赌博'],
  ['作息饮食规律，积极参加文体娱乐活动。', '规律作息'],
  ['合理膳食，健康生活。', '合理膳食'],
  ['发表言论时，言语有度、真诚待人。', '真诚待人'],
  ['产生分歧时，平心静气，以理服人。', '以理服人'],
  ['多独立思考，不随波逐流。', '独立思考'],
  ['绿色健康出行。', '绿色出行'],
  ['少用或不用一次性餐具。', '不用一次性餐具'],
  ['不买过度包装和污染环境的商品。', '拒绝白色污染'],
  ['在公共场所，不旁若无人大声讲电话。', '讲公德'],
  ['在图书馆等安静场所，手机静音是一种尊重。', '不喧哗'],
  ['电梯里不乱跳，不大声讲话。', '电梯不打闹'],
  ['上下楼梯不打闹，楼道内不奔跑。', '楼道不乱跑'],
  ['公共场所不赤膊、不穿睡衣和拖鞋。', '文明穿衣'],
  ['社交场合讲礼仪，咳嗽喷嚏掩口鼻。', '咳嗽掩鼻'],
  ['上门做客不迟到、不多言、守礼节。', '拜访有礼节'],
  ['文明用餐，拒绝野味。', '拒绝野味'],
  ['不剩菜、不剩饭，争做光盘一族。', '不浪费食物'],
  ['外出聚餐，尽量使用公筷公勺。', '外出用公筷'],
  ['不乱吐、不乱扔、不喧哗。', '不乱扔不乱吐'],
  ['小孩不喝酒，大人不拼酒，酒后不驾车。', '酒后不驾车'],
  ['不闯红灯、不乱穿马路、不翻越护栏。', '不乱穿马路'],
  ['不污损公共用品，不损坏公共设施。', '不破坏公物'],
  ['衣着整洁得体，礼让老幼病残。', '礼让老幼病残'],
  ['有序排队上下、主动让座不抢座。', '主动让座'],
  ['不酒驾、不疲劳驾驶、不分心驾驶，开车不斗气。', '开车不斗气'],
  ['斑马线前礼让行人，不抢道先行。', '开车礼让行人'],
  ['文明停车，不违规乱停。', '不违规停车'],
  ['不开窗抛物，不随意鸣笛。', '不开窗抛物'],
  ['戴安全头盔、不闯红灯、不逆行、不玩手机、不乱放。', '骑车不玩手机'],
  ['骑车上路，按道通行。', '骑车按道通行'],
  ['不骑车带人，不违章载物。', '不违章载物'],
  ['不破坏花草树木、不损毁景区文物和设施。', '爱护花草'],
  ['不吵民、不扰民、不影响他人。', '不吵民不扰民'],
  ['遛狗要牵绳、粪便及时清。', '文明养犬'],
  ['不乱堆乱放、不乱搭乱建、不乱贴乱画。', '不乱搭建'],
  ['公共场合，不大声喧哗，不讲粗话脏话。', '不讲粗话脏话'],
  ['乘车外出，观影购物，排队等候，礼让有序。', '礼让有序'],
  ['办事排队不插，不越一米线。', '不插队'],
  ['文明交往，礼貌待人。', '礼貌待人'],
  ['友善对待外来人员。', '友善待人'],
  ['耐心热情回应陌生人的问路、求助等。', '热心助人'],
  ['保持阳台、楼道整洁，不乱堆物品，不乱扔废弃物。', '保持楼道整洁'],
  ['保持小区、院落环境整齐，不乱停放车辆，不乱晾晒衣被。', '保持小区整洁'],
  ['邻里和睦，不传闲话，不闹纠纷。', '邻里和睦'],
  ['维护社会治安，不打架骂人，不违反防火规定。', '不打架骂人'],
  ['不携带危险物品和有碍乘客安全的物品及动物乘车。', '不携带危险物'],
  ['文明礼貌购物，货款当面点清。', '文明购物'],
  ['依法维护权益，友善处理问题。', '依法维护权益'],
  ['遇到不良现象，敢于主持正义。', '敢于见义勇为'],
  ['团结友爱，互帮互助。', '团结互助'],
  ['爱岗敬业，诚实守信，奉献社会。', '爱岗敬业'],
  ['爱护环境卫生，保持环境整洁。', '爱护环境卫生'],
  ['养成文明、环保、健康生活方式。', '健康生活'],
  ['热爱祖国，热爱人民，热爱家乡。', '爱国爱家乡'],
  ['铭记党恩，不忘初心，牢记使命。', '牢记使命'],
  ['明德有礼，大义向善。', '明德有礼'],
  ['遵纪守法，自律自强。', '遵纪守法'],
  ['乐观积极向上的生活态度。', '积极乐观'],
  ['做孩子的良师益友。', '做孩子的朋友'],
  ['响应“禁塑”号召，保护生态环境。', '少用塑料袋'],
  ['相逢报以微笑，见面说声您好。', '礼貌待人'],
  ['不信仰邪教。', '不信仰邪教'],
  ['拒绝校园霸凌，团结友爱，不欺负他人。', '拒绝校园霸凌'],
]
